import { authHeader } from '../helpers';

const getAll = async () => {
  const requestOptions = {
    method: 'GET',
    headers: {...authHeader(), "ngrok-skip-browser-warning": "69420"},
  };

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/question_topics/`, requestOptions);
  return handleResponse(response);
};

const getQuestionCounts = async () => {
  const requestOptions = {
    method: 'GET',
    headers: {...authHeader(), "ngrok-skip-browser-warning": "69420"},
  };

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/question_topics/counts`, requestOptions);
  return handleResponse(response);
};

const create = async (vn_name: string) => {
  const requestOptions = {
    method: 'POST',
    headers: {...authHeader(), 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "69420"},
    body: JSON.stringify({ vn_name })
  };

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/question_topics/`, requestOptions);
  return handleResponse(response);
};

const update = async (id: number, vn_name: string) => {
  const requestOptions = {
    method: 'PUT',
    headers: {...authHeader(), 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "69420"},
    body: JSON.stringify({ vn_name })
  };

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/question_topics/${id}`, requestOptions);
  return handleResponse(response);
};

const deleteTopic = async (id: number) => {
  const requestOptions = {
    method: 'DELETE',
    headers: {...authHeader(), "ngrok-skip-browser-warning": "69420"},
  };

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/question_topics/${id}`, requestOptions);
  return handleResponse(response);
};

function handleResponse(response: any) {
  return response.text().then((text: string) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

export const questionTopicService = {
  getAll,
  getQuestionCounts,
  create,
  update,
  deleteTopic,
};
